define('editor/edit/index',['durandal/app', 'plugins/http', 'jquery', 'knockout', 'plugins/router'], function (app, http, $, ko, router) {
    var viewmodel = function () {
        var self = this;

        self.map = ko.observable();
        self.actions = ko.observable();
        self.context = ko.observable();
        self.heartBeatTimer = null;
        self.isDirty = ko.observable(true); // assume dirty as soon as they open to edit. Clicking "Save" button cleans map
        self.authbypasskey = ko.observable();

        self.activate = function (editorMapId) {
            self.editorMapId = editorMapId;
            if (router.activeInstruction().queryParams) {
                if (router.activeInstruction().queryParams['authbypasskey']) {
                    self.authbypasskey(router.activeInstruction().queryParams['authbypasskey']);
                }
            }

            self.fetchEditorMap(self.editorMapId)
                .then(self.initialiseChildModules);

            self.registerEventHandlers();
        };

        self.compositionComplete = function () {
            setTimeout(function() {
                if (self.editorMap.readOnly) {
                    $('.leaflet-draw-toolbar').hide();
                } else {
                    $('.leaflet-draw-toolbar').show();
                }
            }, 200);
        };

        self.canDeactivate = function () {
            if (!self.editorMap || self.editorMap.locked || self.editorMap.readOnly) {
                return true;
            }

            if (self.isDirty()) {
                return app.showMessage('Your draft changes will be kept, but a new version won\'t be created until you save.', 'Exit without saving?', ['Exit', 'Cancel']).then(function (response) {
                    var exit = response && response === 'Exit';
                    if (exit) {
                        self.clearLock();
                        self.deactivate();
                    }
                    return exit;
                });
            }

            self.clearLock();
            self.deactivate();
            return true;
        };

        self.deactivate = function () {
            if (self.editorMap && !self.editorMap.locked) {
                window.clearInterval(self.heartBeatTimer);
            }
            
            if (self.context().model.content().model.deactivate) {
                self.context().model.content().model.deactivate();
            }
            app.off('editormap:edit:request');
        };

        self.registerEventHandlers = function () {
            app.on('editormap:saved', self.setClean);
        };

        self.setClean = function () {
            self.isDirty(false);
        };

        self.fetchEditorMap = function (id) {
            var url = "/api/editor/edit/" + id;

            return http.get(url, { authbypasskey: self.authbypasskey() })
                .then(self.processMapData)
                .fail(app.showError);
        };

        self.processMapData = function (response) {
            if (!response.data) {
                return app.showError(response, "Unexpected Error", "Unable to retrieve map");
            }
            
            self.editorMap = response.data.editorMap;
            if (!self.editorMap.readOnly) {
                self.processMapLockState();
            }
        };

        self.processMapLockState = function () {
            if (self.editorMap.readOnly && !self.editorMap.locked) {
                return;
            }

            if (self.editorMap.locked) {
                app.showMessage("This map is locked for edit by another user", "Locked For Editing", ['Ok']);
            } else {
                self.startLockForEditingHeartBeat();
            }
        };

        self.startLockForEditingHeartBeat = function () {
            if (!self.heartBeatTimer) {
                self.heartBeatTimer = window.setInterval(self.heartBeatTick, 10000);
            }
        };

        self.heartBeatTick = function () {
            var url = '/api/editor/edit/heartbeat',
                data = {
                    editorMapId: self.editorMapId
                };

            return http.post(url, data)
                .then(function(response) {
                    if (!response.success) {
                        if (self.heartBeatTimer) {
                            window.clearInterval(self.heartBeatTimer);
                            self.heartBeatTimer = null;
                        }
                        app.showMessage("Your map edit lock was revoked by an admin. You will be returned to the map list page. Your draft changes have been saved.", "Map edit lock revoked by admin", ['Ok'])
                            .then(function() {
                                self.setClean();
                                router.navigate('/editor/list');
                            });
                    }
                })
                .fail(function (response) {
                    window.clearInterval(self.heartBeatTimer);
                    self.heartBeatTimer = null;
                    app.showError(response, 'Network Error', 'We cannot contact the server. Please refresh the map before making further changes.');
                });
        };

        self.clearLock = function () {
            var url = '/api/editor/edit/heartbeat/release',
                data = {
                    editorMapId: self.editorMapId
                };
            
            return http.post(url, data);
        };

        self.initialiseChildModules = function () {
            self.map({ model: 'editor/edit/map/index', activationData: [self.editorMap, false] });
            self.actions({ model: 'editor/edit/actions/index', activationData: [self.editorMap] });
            self.context({ model: 'editor/edit/contexts/index', activationData: [self.editorMap] }); // the layers list is one of the "context" views
        };
    };

    return viewmodel;
});

